import React from 'react';

export default function LoadingSpinner({ fullPage = false, text = "Caricamento in corso" }) {
  return (
    <div className={`d-flex flex-column justify-content-center align-items-center ${fullPage ? 'vh-100 bg-dark' : ''}`}>
      {/* Container logo */}
      <div className="position-relative mb-4">
        {/* Logo con effetto "splash" di colore */}
        <img
          src="/logo.png"
          alt="FantaWrestling"
          className="position-relative"
          style={{
            width: '80px',
            height: '80px',
            zIndex: 2,
            animation: 'gentleBounce 1.5s ease-in-out infinite'
          }}
        />
        
        {/* Cerchio di caricamento semplice */}
        <div 
          className="position-absolute rounded-circle"
          style={{
            width: '100px',
            height: '100px',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            border: '3px solid transparent',
            borderTop: '3px solid #ffc107',
            animation: 'simpleSpin 1s linear infinite',
            zIndex: 1
          }}
        />
        
        {/* Puntino che gira intorno 
        <div 
          className="position-absolute bg-warning rounded-circle"
          style={{
            width: '12px',
            height: '12px',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            animation: 'orbit 2s linear infinite',
            zIndex: 3
          }}
        />
            */}
      </div>
      
      {/* Testo con ellissi animate */}
      <div className="text-center">
        <p className="text-warning fw-bold mb-0" style={{ fontSize: '1.1rem' }}>
          {text}
          <span className="loading-dots">
            <span style={{ animation: 'dot 1.5s infinite' }}>.</span>
            <span style={{ animation: 'dot 1.5s infinite 0.2s' }}>.</span>
            <span style={{ animation: 'dot 1.5s infinite 0.4s' }}>.</span>
          </span>
        </p>
      </div>
      
      {/* Stili minimali */}
      <style>{`
        @keyframes gentleBounce {
          0%, 100% { 
            transform: scale(1); 
            filter: brightness(1);
          }
          50% { 
            transform: scale(1.1); 
            filter: brightness(1.2);
          }
        }
        
        @keyframes simpleSpin {
          0% { transform: translate(-50%, -50%) rotate(0deg); }
          100% { transform: translate(-50%, -50%) rotate(360deg); }
        }
        
        @keyframes orbit {
          0% {
            transform: translate(-50%, -50%) rotate(0deg) translateX(45px) rotate(0deg);
          }
          100% {
            transform: translate(-50%, -50%) rotate(360deg) translateX(45px) rotate(-360deg);
          }
        }
        
        @keyframes dot {
          0%, 100% { opacity: 0; }
          50% { opacity: 1; }
        }
        
        .loading-dots {
          display: inline-block;
          width: 40px;
          text-align: left;
        }
      `}</style>
    </div>
  );
}